module.exports = __webpack_public_path__ + "media/3_6-3.b719a6f6.mp3";